import styled from "styled-components";
import { ButtonTheme, ColorTheme, ShadowTheme, SpacingTheme } from "../globaStyledComponents/globalStyledComponentsStyling";

export const CancelButton = styled.button`
    background: none;
    border: none;
    text-decoration: underline;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    cursor: pointer;
    padding: 0;
`;

export const CrossButton = styled.button`
    width: 44px;
    height: 44px;
    padding: 10px;
    border-radius: 50%;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid ${ColorTheme.White.color};
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        background: rgba(255, 255, 255, 0.85);
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
        border: 1px solid ${ColorTheme.White.color};
    }
    &:active {
        background: rgba(255, 255, 255, 0.85);
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
        border: 1px solid ${ColorTheme.White.color};
    }
`;

export const RightPopup = styled.div`
    position: fixed;
    width: 100%;
    height: 100vh;
    bottom: 0;
    right: 0;
    border-radius: 32px 32px 0 0;
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    display: flex;
    background: rgba(255, 255, 255);
    flex-direction: column;
    z-index: 102;
    align-items: center;
    min-height: fit-content;

    @media (min-width: 768px) {
        width: 568px;
        height: 100%;
        border-radius: 32px 0 0 32px;
        top: 0;
        margin: 0 auto;

        ${CancelButton} {
            display: none;
        }
    }
`;
interface CenterPopupProps {
    desktopWidth?: string;
    height?: string;
    desktopHeight?: string;
    backgroundColor?: string;
}
export const CenterPopup = styled.div<CenterPopupProps>`
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    border-radius: 32px 32px 0 0;
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    display: flex;
    background: ${(props) => props.backgroundColor || 'rgba(255, 255, 255, 0.85)'};
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    flex-direction: column;
    z-index: 102;
    align-items: center;
    min-height: fit-content;
    height: ${(props) => (props.height ? props.height : "fit-content")};

    @media (min-width: 768px) {
        width: ${(props) => (props.desktopWidth ? props.desktopWidth : "568px")};
        height: ${(props) => (props.desktopHeight ? props.desktopHeight : "auto")};
        max-height: 90vh;
        border-radius: 32px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
`;

export const CenterPopupContent = styled.div`
    flex: 1;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    
    /* Safari-specific scrollbar hiding */
    &::-webkit-scrollbar {
        display: none;
        -webkit-appearance: none;
    }
    
    /* Firefox scrollbar hiding */
    scrollbar-width: none;
`;

interface CancelAndSaveButtonsProps {
    shadow?: boolean;
}

export const CancelAndSaveButtons = styled.div<CancelAndSaveButtonsProps>`
    width: 100%;
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    padding: ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_400.padding};
    margin-top: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
    box-shadow: ${(props) => (props.shadow ? ShadowTheme.shadow_300.boxShadow : 'none')};
    
    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_400.padding};
        border-radius: 0 0 32px 32px;
        background-color: transparent;
    }
`;

export const ChildrenContainer = styled.div`
    width: 100%;
    overflow-y: scroll;
    margin-top: 66px;
    padding: 0 24px;
    flex: 1;

    ::-webkit-scrollbar {
        display: none;
    }
    @media (min-width: 768px) {
        margin-top: 84px;
    }
`;

// full screen popup
interface FullScreenPopupWrapperProps {
    mobileHeight?: string;
}
export const FullScreenPopupWrapper = styled.div<FullScreenPopupWrapperProps>`
    position: fixed;
    width: 100%;
    height: ${(props) => (props.mobileHeight ? props.mobileHeight : "98%")};
    bottom: 0;
    left: 0;
    border-radius: ${(props) => (props.mobileHeight === "100%" ? "0" : "16px 16px 0 0")};
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${ColorTheme.White.color};
    z-index: 102;

    @media (min-width: 768px) {
        border-radius: unset;
        height: 100%;
    }
`;
interface FullScreenPopupContentWrapperProps {
    noPadding?: boolean;
}
export const FullScreenPopupContentWrapper = styled.div<FullScreenPopupContentWrapperProps>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: ${(props) => (props.noPadding ? "0 0" : `${SpacingTheme.spacing_600.padding} ${SpacingTheme.spacing_400.padding} 0`)};
    overflow-x: hidden;
    overflow-y: auto;
    ::-webkit-scrollbar {
        display: none;
    }
    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_1000.padding} ${SpacingTheme.spacing_300.padding} 0;
        width: calc(640px + 32px);
    }
`;
export const FullScreenPopupBtnWrapper = styled.div`
    background: ${ColorTheme.White.color};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_400.padding};
    margin-top: auto;
    border-top: 1px solid ${ColorTheme.Grey2.color};
    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_800.padding};
    }
`;
export const FullScreenPopupCancelBtn = styled.button`
    background: none;
    border: none;
    text-decoration: underline;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    cursor: pointer;
`;
export const FullScreenContinueBtnImg = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 8px;
`;
